<nav class="navbar navbar-expand-lg glass fixed-top">
    <div class="container-fluid">
        <div class="navbar-left">
            <div class="navbar-wrapper">
                <a class="navbar-brand" href="javascript:void(0)">
                    <span class="navbar-title">{{getTitle()}}</span>
                </a>
            </div>
        </div>

        <div class="collapse navbar-collapse justify-content-end" id="navigation">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <button class="nav-link btn-profile" [matMenuTriggerFor]="profileMenu">
                        <i class="material-icons">account_circle</i>
                        <span class="nav-user-label">Account</span>
                    </button>
                    <mat-menu #profileMenu="matMenu" class="modern-menu">
                        <button mat-menu-item (click)="navigateToProfile()">
                            <mat-icon>person</mat-icon>
                            <span>Profile</span>
                        </button>
                        <div class="mat-menu-divider"></div>
                        <button mat-menu-item [disabled]="logoutButtonDisable"
                            (click)="!logoutButtonDisable && logout()" class="logout-item">
                            <mat-icon>logout</mat-icon>
                            <span>Logout</span>
                        </button>
                    </mat-menu>
                </li>
            </ul>
        </div>
    </div>
</nav>